import { Component, Inject, Input, OnChanges, OnInit, Optional, SimpleChanges } from '@angular/core';
import { GridModalComponent } from '@app/core/components/grid/grid.decorators';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { GetStockStatusDrillDownParams, StockService, StockStatusDrillDownGet } from '@app/services/stock.service';

@GridModalComponent('stockstatusdrilldown')
@Component({
    selector: 'tt-stock-status-drill-down',
    templateUrl: './stock-status-drill-down.component.html',
    styleUrls: ['./stock-status-drill-down.component.css'],
})
export class StockStatusDrillDownComponent implements OnInit, OnChanges {
    @Input()
    public params?: GetStockStatusDrillDownParams;

    public get?: StockStatusDrillDownGet;

    public grid?: GridOptions;

    constructor(
        private stock: StockService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    private async loadGet() {
        if (!this.params) return;

        this.get = await this.stock.getStockStatusDrillDown(this.params);
    }

    private readGrid() {
        if (!this.get) return;

        if (+this.get.grid_datatask > 0) {
            if (!this.grid) {
                this.grid = new Grid().setRememberId('w_stockstatusdrilldown.grid').setLoadDataFunction({ method: +this.get.grid_datatask, parameters: () => this.params });
            } else {
                this.grid.gridfunc?.read();
            }
        } else {
            delete this.grid;
        }
    }

    private async init() {
        await this.loadGet();
        this.navigator?.setHeading?.(this.get?.page_heading ?? '');
        this.readGrid();
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: 'min(95vw, 180rem)', height: 'min(100rem, 98vh)' });
            this.params = this.navigator.params as unknown as GetStockStatusDrillDownParams;
            this.init();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params']) {
            this.init();
        }
    }
}
